import {APP_BASE_HREF} from '@angular/common';
import {Injectable, Inject} from '@angular/core';

@Injectable()
export class PaymentUrlService {
    constructor(
        @Inject(APP_BASE_HREF) private _baseHref: string
    ) {}
    buildUrlForPaymentHistoryPage(returnUrl:string, vin?:string,allowTempPayment?:string):string{
        const redirectUrl = `${this._baseHref}onstar/onstar-payment-history`;

        //************* Define Parameters *************//

        // requiredParams: Required
        const requiredParams = `?returnUrl=${encodeURIComponent(returnUrl)}`;

        //tempParam,vinParam: Optional
        const tempParam = allowTempPayment ? `&isTempMethodAllowed=${allowTempPayment}` : '';
        const vinParam = vin ? `&vin=${encodeURIComponent(vin)}` : '';

        const queryParams = `${requiredParams}${tempParam}${vinParam}`;
        return `${redirectUrl}${queryParams}`;
    }
}